// @ts-check
/**
 * Materials catalog — shared reference data (fabrics, trims, vendor defaults) reused
 * by both the D2C product BOM and the atelier project BOM.
 */
import api from '../utils/apiClient';

const adminMaterialService = {
  /**
   * @param {Object} [params]
   * @returns {Promise<Object[]>}
   */
  async getMaterials(params = {}) {
    const q = new URLSearchParams();
    if (params.category) q.append('category', params.category);
    if (params.search) q.append('search', params.search);
    if (params.include_deleted) q.append('include_deleted', 'true');
    const qs = q.toString();
    return api.get(`/api/admin/materials${qs ? `?${qs}` : ''}`);
  },

  async getMaterial(materialId) {
    return api.get(`/api/admin/materials/${materialId}`);
  },

  async createMaterial(data) {
    return api.post('/api/admin/materials', data);
  },

  async updateMaterial(materialId, data) {
    return api.put(`/api/admin/materials/${materialId}`, data);
  },

  async deleteMaterial(materialId) {
    return api.del(`/api/admin/materials/${materialId}`);
  },

  async restoreMaterial(materialId) {
    return api.post(`/api/admin/materials/${materialId}/restore`);
  },

  /**
   * Pre-fill defaults (unit_cost, currency, live FX rate, duty%, freight) for a new
   * BOM line referencing this material. Override any of it before saving.
   */
  async getMaterialPrefill(materialId) {
    return api.get(`/api/admin/materials/${materialId}/prefill`);
  },
};

export default adminMaterialService;
